import { useEffect, useState } from "react";

export const useGetKeySize = () => {
    const [keyDiv, setkeyDiv] = useState(Math.random());
    const actualizarTamanio = () => setkeyDiv(Math.random());
    useEffect(() => {
      window.addEventListener('resize', actualizarTamanio);
      return () => window.removeEventListener('resize', actualizarTamanio);
    }, [window]); 
    return keyDiv
  };
  